import { render } from "./CustomSelectOneHorseColor.vue?vue&type=template&id=d955f79e"
import script from "./CustomSelectOneHorseColor.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneHorseColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__